module.exports = __webpack_public_path__ + "static/media/Sabermedics.54344afb.jpg";